export const apiBaseUrl = 'https://apimedecin.rarealecoute.com'
export const proSanteRedictedUrl = 'https://medecin.rarealecoute.com/pro-sante/auth/'
export const proSanteClientId = 'rare-a-lecoute'
export const proSanteAuthEndpoint = 'https://wallet.esw.esante.gouv.fr/auth'
export const notConnectedSpecificToken = 'axYWGq7jWAnuhhLeUso6Nc7NZtAm7PzhrY984cQGh99eFAp'
